import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import {BehaviorSubject, Observable} from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class IpServiceService {

    constructor(private http: HttpClient) { }
    public getIPAddress() {
        return this.http.get<any>('http://api.ipify.org/?format=json')
            .toPromise()
            .then(res => <any>res.ip)
            .then(data => {
                return data;
            });
       //  return this.http.get('http://api.ipify.org/?format=json');
    }
}
